module.exports = "//public.getcloudapp.com/packs/media/images/blurred-drop-c3f7049d6b933728e86d5908b4657d45.png";